import React from 'react';
import {FormBlock, FormSection} from "components/Form/Form";
import {MediaField, TextAreaField, TextField} from "components/Form/Form/Field";
import {TagIcon, TrashIcon} from "@heroicons/react/solid";
import {ImageFile} from "types/MediaFile";
import Button from "components/Button";

export type AdvisoryEditorProps = {
    name: string
    index: number
    image?: ImageFile | null
    onRemove: (index: number) => any
}

function AdvisoryEditor({index, name, image, onRemove}: AdvisoryEditorProps) {
    return (
        <FormSection columns={6} isTop>

            {/* Title */}
            <FormBlock columns={3}>
                <div className="mr-14 sm:mr-0">
                    <TextField
                        name={`${name}.${index}.title`}
                        label="Title *"
                        hint="250 chars max"
                        maxLength={250}
                        icon={TagIcon}
                        help="The title when displayed to the audience"
                        autoComplete="off"
                    />
                </div>
            </FormBlock>

            {/* Body */}
            <FormBlock columns={6}>
                <TextAreaField
                    name={`${name}.${index}.body`}
                    label="Body"
                    hint="Optional. 20,000 chars max."
                    help="The main content of the advisory, when displayed to the audience"
                    autoComplete="off"
                    maxChars={20000}
                    rows={5}
                />
            </FormBlock>

            {/* Image */}
            <FormBlock columns={6}>
                <MediaField
                    name={`${name}.${index}.image_id`}
                    label="Image"
                    hint="Optional"
                    files={image}
                    maxFiles={1}
                    type={MediaField.types.IMAGE}
                />
            </FormBlock>

            {/* Action Buttons */}
            <FormBlock columns={6}>
                <div className="flex justify-end pt-4 border-t border-gray-200">
                    <Button
                        size={Button.sizes.X_SMALL}
                        color={Button.colors.WHITE}
                        icon={TrashIcon}
                        onClick={() => onRemove(index)}
                    />
                </div>
            </FormBlock>
        </FormSection>
    );
}

export default AdvisoryEditor;